import { render, staticRenderFns } from "./MerchandiseDiscountManagement.vue?vue&type=template&id=46fb3e6a&scoped=true&"
import script from "./MerchandiseDiscountManagement.vue?vue&type=script&lang=js&"
export * from "./MerchandiseDiscountManagement.vue?vue&type=script&lang=js&"
import style0 from "./MerchandiseDiscountManagement.vue?vue&type=style&index=0&id=46fb3e6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fb3e6a",
  null
  
)

export default component.exports